import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xxfb",
  "use": "icon-xxfb-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-xxfb\"><path fill=\"#fff\" fill-opacity=\".8\" d=\"m12.308 3.364-4.328.29-4.542-.29L3.654 10l-.216 6.558L10 16.346l6.42.212-.074-4.538.236-4.328h.918V17.5h-15v-15h9.808zm4.615 3.174h-.577V4.572l-5.841 5.488-.204-.205-.203-.204 5.633-5.997h-2.27v-.577L17.5 2.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol